import React from "react";
import AnimatedSection from "../common/AnimatedSection";
import SectionHeading from "../common/SectionHeading";
import hettichLogo from "../../assets/images/tpb/hettich.png";
import higoldLogo from "../../assets/images/tpb/higold.png";
import hafeleLogo from "../../assets/images/tpb/hafele.jpg";
import aristoLogo from "../../assets/images/tpb/aristo.png";
import bergerLogo from "../../assets/images/tpb/berger.png";
import biesseLogo from "../../assets/images/tpb/biesse.avif";
import greenlamLogo from "../../assets/images/tpb/greenlam.png";
import greenplyLogo from "../../assets/images/tpb/greenply.png";
import royalToucheLogo from "../../assets/images/tpb/Royal-touche.png";
import stylamLogo from "../../assets/images/tpb/Stylam-LOGO.png";
import sugatsuneLogo from "../../assets/images/tpb/sugatsune.jpg";
import rehauLogo from "../../assets/images/tpb/REHAU.jpeg";
import aparnaLogo from "../../assets/images/builder/aparna.png";
import vueLogo from "../../assets/images/builder/vue.png";
import brigadeLogo from "../../assets/images/builder/brigade.png";
import edgeImage from "../../assets/images/EDGE.jpg";
import placeholderImage from "../../assets/images/placeholder.jpg";

const brands = [
  { name: "Hettich", logo: hettichLogo },
  { name: "HiGold", logo: higoldLogo },
  { name: "Hafele", logo: hafeleLogo },
  { name: "Aristo", logo: aristoLogo },
  { name: "Berger", logo: bergerLogo },
  { name: "Biesse", logo: biesseLogo },
  { name: "Greenlam", logo: greenlamLogo },
  { name: "Greenply", logo: greenplyLogo },
  { name: "Royal Touche", logo: royalToucheLogo },
  { name: "Stylam", logo: stylamLogo },
  { name: "Sugatsune", logo: sugatsuneLogo },
  { name: "Rehau", logo: rehauLogo },
];

const projects = [
  { name: "Aparna Zicon", logo: aparnaLogo },
  { name: "Veu", logo: vueLogo },
  { name: "Brigade", logo: brigadeLogo },
];

export default function BrandsShowcase() {
  return (
    <section className="section-spacing bg-white">
      <div className="container-custom section-padding">
        {/* Brands Section */}
        <AnimatedSection>
          <SectionHeading
            label="Trusted Partners"
            title="We choose quality brands because you deserve the best."
            align="center"
          />
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-8 mt-12">
            {brands.map((brand, index) => (
              <AnimatedSection
                key={brand.name}
                delay={index * 50}
                className="flex items-center justify-center"
              >
                <div className="w-full aspect-[2/1] flex items-center justify-center p-4 bg-white rounded-xl hover:shadow-soft transition-shadow">
                  <img
                    src={brand.logo}
                    alt={brand.name}
                    className="w-full h-full object-contain"
                  />
                </div>
              </AnimatedSection>
            ))}
          </div>
        </AnimatedSection>

        {/* Projects Section */}
        <AnimatedSection className="mt-20">
          <SectionHeading
            label="Our Work"
            title="Spaces we've created with builders and developers."
            align="center"
          />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
            {projects.map((project, index) => (
              <AnimatedSection
                key={project.name}
                delay={index * 100}
                className="flex items-center justify-center"
              >
                <div className="w-full aspect-[2/1] flex items-center justify-center p-4 bg-white rounded-xl hover:shadow-soft transition-shadow">
                  <img
                    src={project.logo}
                    alt={project.name}
                    className="w-full h-full object-contain"
                  />
                </div>
              </AnimatedSection>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
